import * as cookieMessageActions from "./cookieMessage.actions";

export default {
  "more-information": {
    gdpr: () => cookieMessageActions.setOpenState(true),
    "gdpr-settings": () => cookieMessageActions.toggleSettings()
  }
};
